import React from 'react';
import { HTMLtoJSX } from '../../../../../../helpers';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import s from './index.module.scss';

type FestivalFooterCopyrightProps = {
  copyright: string;
};

export default function FestivalFooterCopyright(
  props: FestivalFooterCopyrightProps,
) {
  const { location } = useRootSelector(selectPageConfig);

  return (
    <div className={s.wrapper}>{HTMLtoJSX(props.copyright, location)}</div>
  );
}
